import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import {
    CircularProgress, Tooltip, FormControl, Grid, Checkbox, InputLabel, MenuItem, Paper, Select, TextField, IconButton
} from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Box } from "@mui/system";
import { useLocation } from "react-router-dom";
import { SnackBarAlert } from "../../../utils/SnackBar";
import TopHeading from "../../../utils/TopHeading/TopHeading";
import styled from "@emotion/styled";
import { Stack } from "@mui/system";
import { createAffiliateDetail, getAffiliateDetail, updateAffiliateDetail, getAllCallbackType } from "../affiliateMaster.api";
import { useNavigate } from "react-router-dom";
import { fetchAllCountry } from "../../country/country.api";
import MultipleValueDropDown from "../../../utils/multipleValueDropDown/MultipleValueDropDown";
import AsyncDropdown from "../../../utils/asyncDropdown/AsyncDropdown";
import { copyToClipboard } from "../../../utils/copyToClipboard/copyToClipboard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import TaskAltSharpIcon from '@mui/icons-material/TaskAltSharp';
const CreateAffiliate = () => {
    const MyComponent = styled("button")({
        backgroundColor: "white",
        color: "black",
        padding: "16px",
        borderWidth: "1px",
        borderRadius: "10px",
        "&:hover": {
            backgroundColor: "black",
            color: "white",
        },
    });

    const dropDowns = { CALLBACKTYPE: "CALLBACKTYPE", REQUESTTYPE: "REQUESTTYPE", PAYOUTTYPE: "PAYOUTTYPE" };

  const [alert, setAlert] = useState(false);
  const [isTextCopied, setIsCopied] = useState(null);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [countriesSelected, setCountriesSelected] = useState([]);
  const [callbackType, setCallbackType] = useState([]);
  const [selectedCallbackType, setSelectedCallbackType] = useState([]);
  const [requestTypeSelected, setRequestTypeSelected] = useState([]);
  const [payoutTypeSelected, setpayoutTypeSelected] = useState([]);
  const [mobileUrlCopied, setMobileUrlCopied] = useState(false);
  const [webUrlCopied, setWebUrlCopied] = useState(false);
  const [callbackUrlCopied, setCallbackUrlCopied] = useState(false);
  const adminId = useSelector((state) => state.auth.userData?.adminId);
  const requestTypes = [
    { requestTypeId: "get", requestType: "GET" },
    { requestTypeId: "post", requestType: "POST" },
  ];
  const payoutTypes = [
    { payoutTypeId: 1, payoutType: "Signup" },
    { payoutTypeId: 2, payoutType: "DOI" },
  ];
  const [affiliateData, setAffiliateData] = useState({
    id: null,
    panelId: 30,
    affiliateName: "",
    affiliateUrl: "",
    affiliateWebUrl: "",
    affiliateCallbackUrl: "",
    callbackTypeId: 0,
    payoutType: 0,
    requestType: "",
    cost: 0,
    contactEmail: "",
    billingEmail: "",
    createdBy: adminId,
    countryIds: [],
    vpn: true,
    proxy: true,
    emailFraudScore: 70,
    ipFraudScore: 70,
  });

  const handleCloseAlert = () => {
    setAlert(false);
  };

  const [validationError, setvalidationError] = useState({
    affiliateName: "",
    countries: "",
    callbackTypeId: "",
    payoutType: "",
    requestType: "",
    ipFraudScore: "",
    emailFraudScore: "",
    contactEmail: "",
    billingEmail: "",
    vpn: "",
    proxy: "",
  });

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAffiliateData((prev) => ({
            ...prev,
            [name]: value,
        }));

          if (name === "contactEmail" || name === "billingEmail") {
          if (value && !isValidEmail(value)) {
            setvalidationError((prev) => ({
              ...prev,
              [name]: "Please enter a valid email address",
            }));
          } else {
            setvalidationError((prev) => ({
              ...prev,
              [name]: "",
            }));
          }
        } else if (name === "ipFraudScore" || name === "emailFraudScore") {
          if (value !== "" && Number(value) === 0) {
            setvalidationError((prev) => ({ ...prev, [name]: "Fraud Score should be greater than 0" }));
          } else {
            setvalidationError((prev) => ({ ...prev, [name]: "" }));
          }
        }
        else {
          setvalidationError((prev) => ({ ...prev, [name]: "" }));
        }
    };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setAffiliateData((prev) => ({
      ...prev,
      [name]: checked,
    }));
    setvalidationError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

    useEffect(() => {
        fetchAllCountry()
            .then((res) => {
                if (res?.status === 200) {
                    setCountries(res.data.data);
                } else {
                    // console.log(res);
                }
            })
            .catch((err) => {
                console.log(err);
            });

        getAllCallbackType()
            .then((res) => {
                if (res?.status === 200) {
                    setCallbackType(res.data.data);
                } else {
                   
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [adminId])

    const type = location.pathname.split('/')[2];
    let affiliateId = parseInt(location.pathname.split('/')[3]);
    const hasFetched = useRef(false);

  useEffect(() => {
    if (
      type === "edit-affiliate" &&
      affiliateId &&
      countries.length > 0 &&
      callbackType.length > 0 &&
      !hasFetched.current
    ) {
      hasFetched.current = true;

      getAffiliateDetail(affiliateId)
        .then((res) => {
          if (res.status === 200) {
            const affilicatedata = res.data.data[0];
            const customAffData = {
                ...affilicatedata,
                ipFraudScore: affilicatedata?.ipFraudScore ?? 70,
                vpn: affilicatedata?.vpn ?? true,
                proxy: affilicatedata?.proxy ?? true,
                emailFraudScore: affilicatedata?.emailFraudScore ?? 70,
              }

            setAffiliateData(customAffData);

            const stringarray = affilicatedata.countries.split(",");
            const countryArray = stringarray
              .map((x) => countries.find((i) => i.countryId === Number(x)))
              .filter(Boolean);
            setCountriesSelected(countryArray);

            const cbItem = callbackType.find(
              (i) => i.id === affilicatedata.callbackTypeId,
            );
            if (cbItem) setSelectedCallbackType(cbItem);

            const reqItem = requestTypes.find(
              (i) => i.requestTypeId === affilicatedata.requestType,
            );
            if (reqItem) setRequestTypeSelected(reqItem);

            const payItem = payoutTypes.find(
              (i) => i.payoutTypeId === affilicatedata.payoutType,
            );
            if (payItem) setpayoutTypeSelected(payItem);
          }
        })
        .catch(console.log);
    }
  }, [affiliateId, type, countries.length, callbackType.length]);

    const navigate = useNavigate();

    const handleSubmit = () => {
        // console.log("clicked", type);
        let data = { ...affiliateData };
        data.countryIds = countriesSelected.map(obj => obj.countryId);
        data.callbackTypeId = selectedCallbackType.id
        data.requestType = requestTypeSelected.requestTypeId;
        data.payoutType = payoutTypeSelected.payoutTypeId;
        data.updatedBy = adminId;
        data.createdBy = adminId;
        let duplicate = {
        affiliateName: "",
        countries: "",
        callbackTypeId: "",
        payoutType: "",
        requestType: "",
        ipFraudScore: "",
        emailFraudScore: "",
        contactEmail: "",
        billingEmail: "",
        vpn: "",
        proxy: "",
    };

        if (data.affiliateName === undefined || data.affiliateName === "") {
            duplicate["affiliateName"] = "Affiliate name is required";
        }
        if (data.callbackTypeId === undefined || data.callbackTypeId === 0) {
            duplicate["callbackTypeId"] = "Callback type is required";
        }
        if (data.requestType === undefined || data.requestType === "") {
            duplicate["requestType"] = "Request Type is required";
        }
        if (data.payoutType === undefined || data.payoutType === 0) {
            duplicate["payoutType"] = "Payout Type is required";
        }
        if (data.affiliateCallbackUrl) {
            if (data.cost === "" || data.cost === undefined || data.cost === null) {
                duplicate["cost"] = "Cost is required";
            } else if (Number(data.cost) === 0) {
                duplicate["cost"] = "Cost should be greater than 0";
            }
        }
        if (countriesSelected && countriesSelected.length < 1) {
            duplicate["countries"] = "Selecte Atleast One Country";
        }
        const ipScore = Number(data.ipFraudScore);
        const emailScore = Number(data.emailFraudScore);

        if (data.emailFraudScore === "" || data.emailFraudScore === null || data.emailFraudScore === undefined) {
            duplicate["emailFraudScore"] = "Fraud Score should be greater than 0";
        } else if (emailScore === 0) {
            duplicate["emailFraudScore"] = "Fraud Score should be greater than 0";
        }

        if (data.ipFraudScore === "" || data.ipFraudScore === null || data.ipFraudScore === undefined) {
            duplicate["ipFraudScore"] = "Fraud Score should be greater than 0";
        } else if (ipScore === 0) {
            duplicate["ipFraudScore"] = "Fraud Score should be greater than 0";
        }

        if (data.contactEmail && !isValidEmail(data.contactEmail)) {
          duplicate["contactEmail"] = "Please enter a valid email address";
        }

        if (data.billingEmail && !isValidEmail(data.billingEmail)) {
          duplicate["billingEmail"] = "Please enter a valid email address";
        }

        setvalidationError(duplicate);
        const noError = Object.values(duplicate).every(
            (x) => x === null || x === ""
        );
        if (!noError) {
            return;
        }

        setLoading(true);
        if (type === "edit-affiliate") {
            updateAffiliateDetail(data.id, data)
                .then((res) => {
                    if (res?.status === 200) {
                        setAlert("Affiliated Updated successfully");
                    } else {
                      setAlert("Failed to update affiliate. Please contact to dev team.");
                    }
                })
                .catch((err) => {
                    setAlert("Something went wrong");
                })
                .finally(() => setLoading(false));
        } else {
            createAffiliateDetail(data)
                .then((res) => {
                    // console.log("create aff resp: ", res.data)
                    if (res?.status === 200) {
                        navigate(`/admin/edit-affiliate/${res?.data?.data?.id}`);
                        setAlert("Affiliated created successfully");
                        setAffiliateData({
                            id: null,
                            panelId: 30,
                            affiliateName: "",
                            affiliateUrl: "",
                            affiliateWebUrl: "",
                            affiliateCallbackUrl: "",
                            callbackTypeId: 0,
                            payoutType: 0,
                            requestType: "",
                            cost: 0,
                            createdBy: adminId,
                            countryIds: [],
                            contactEmail: "",
                            billingAddress: ""
                        })
                    } else {
                       setAlert("Failed to create affiliate. Please contact to dev team.");
                    }
                })
                .catch((err) => {
                    setAlert("Something went wrong");
                })
                .finally(() => setLoading(false));
        }
    };

    const handleCancel = () => {
        navigate(`/admin/affiliate-master`);
    }

  const handleCopyClick = (type) => {
    if (type === "mobile") {
      setMobileUrlCopied(true);
    } else if (type === "web") {
      setWebUrlCopied(true);
    } else {
      setCallbackUrlCopied(true);
    }
  };

      const handleCopy = async (text, fieldName) => {
        const isCopied = await copyToClipboard(text, (message) => {
        setAlert(message);
      });
        if (isCopied) {
        setIsCopied(fieldName);
    
        setTimeout(() => {
          setIsCopied(null);
        }, 2000);
      }
      };

    const handleDropDownChange = (value, dropDownName) => {
        switch (dropDownName) {
            case dropDowns.CALLBACKTYPE:
                setSelectedCallbackType(value);
                setvalidationError((prev) => ({
                    ...prev,
                    callbackTypeId: "",
                }));
                break;
            case dropDowns.REQUESTTYPE:
                setRequestTypeSelected(value);
                setvalidationError((prev) => ({
                    ...prev,
                    requestType: "",
                }));
                break;
            case dropDowns.PAYOUTTYPE:
                setpayoutTypeSelected(value);
                setvalidationError((prev) => ({
                    ...prev,
                    payoutType: "",
                }));
                break;

            default:
                break;
        }
    };

  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    // Validate if the pressed key is a valid digit (0-9) or a decimal point
    if (!/^\d$/.test(keyValue) && keyValue !== ".") {
      event.preventDefault(); // Prevent the key press from being registered
    }
  };

  return (
    <>
      <TopHeading
        link={"/admin/affiliate-master"}
        heading={"Affiliate Master Detail"}
        showButton={Boolean(false)}
      />
      <Box sx={{ mx: 4, mt: 4 }}>
        <Stack direction={"row"} alignItems={"flex-start"}>
          <Paper elevation={2} sx={{ my: 4, p: 2, mr: 2, width: "100%" }}>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columnSpacing={{ xs: 2, md: 15 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
              sx={{ mb: 4 }}
            >
              <Grid item xs={2} sm={4} md={4}>
                <TextField
                  fullWidth
                  multiline
                  name={"affiliateName"}
                  value={affiliateData?.affiliateName}
                  onChange={handleInputChange}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Affiliate Name"}
                  error={Boolean(validationError.affiliateName)}
                  helperText={validationError.affiliateName}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <AsyncDropdown
                  value={selectedCallbackType}
                  options={callbackType}
                  objKey={"callbackType"}
                  stylized
                  label={"CallbackType"}
                  handleChange={(value) =>
                    handleDropDownChange(value, dropDowns.CALLBACKTYPE)
                  }
                  error={Boolean(validationError?.callbackTypeId)}
                  helperText={validationError?.callbackTypeId}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <AsyncDropdown
                  value={requestTypeSelected}
                  options={requestTypes}
                  objKey={"requestType"}
                  stylized
                  label={"requestType"}
                  handleChange={(value) =>
                    handleDropDownChange(value, dropDowns.REQUESTTYPE)
                  }
                  error={Boolean(validationError?.requestType)}
                  helperText={validationError?.requestType}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={12}>
                <TextField
                  fullWidth
                  multiline
                  name={"affiliateUrl"}
                  value={affiliateData?.affiliateUrl}
                  onChange={handleInputChange}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Mobile traffic URL"}
                  InputProps={{
                    readOnly: true,
                    className: "copy-url-field",    
                    endAdornment: (
                      <Tooltip title="Copy to clipboard">
                        <IconButton
                          onClick={() => handleCopy(affiliateData?.affiliateUrl, "affiliateUrl")}
                          style={{ pointerEvents: "auto" }}
                        >
                          {isTextCopied === "affiliateUrl" ?  <TaskAltSharpIcon fontSize='medium' /> : <ContentCopyIcon />}
                        </IconButton>
                      </Tooltip>
                    ),
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={2} sm={4} md={12}>
                <TextField
                    fullWidth
                    multiline
                    name={"affiliateWebUrl"}
                    value={affiliateData?.affiliateWebUrl}
                    onChange={handleInputChange}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "2px solid #f0f0f0",
                      },
                    }}
                    label={"Website traffic URL"}
                    InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <Tooltip title="Copy to clipboard">
                        <IconButton
                          onClick={() => handleCopy(affiliateData?.affiliateWebUrl, "affiliateWebUrl")}
                          style={{ pointerEvents: "auto" }}
                        >
                         {isTextCopied === "affiliateWebUrl" ?  <TaskAltSharpIcon fontSize='medium' /> : <ContentCopyIcon />}
                        </IconButton>
                      </Tooltip>
                    ),
                  }}
                    variant="filled"
                  />
              </Grid>
              <Grid item xs={2} sm={4} md={12}>
                 <TextField
                    fullWidth
                    multiline
                    name={"affiliateCallbackUrl"}
                    value={affiliateData?.affiliateCallbackUrl}
                    onChange={handleInputChange}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "2px solid #f0f0f0",
                      },
                    }}
                    label={"Callback URL"}
                    InputProps={{
                    endAdornment: (
                      <Tooltip title="Copy to clipboard">
                        <IconButton
                          onClick={() => handleCopy(affiliateData?.affiliateCallbackUrl, "affiliateCallbackUrl")}
                          style={{ pointerEvents: "auto" }}
                        >
                          {isTextCopied === "affiliateCallbackUrl" ?  <TaskAltSharpIcon fontSize='medium' /> : <ContentCopyIcon />}
                        </IconButton>
                      </Tooltip>
                    ),
                  }}
                    error={Boolean(validationError.affiliateCallbackUrl)}
                    helperText={validationError.affiliateCallbackUrl}
                  />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <MultipleValueDropDown
                  value={countriesSelected}
                  options={countries}
                  objkey={"countryName"}
                  label={"Select Countries"}
                  onChange={(value) => {
                    setCountriesSelected(value);
                    if (value) {
                      setvalidationError((prev) => ({
                        ...prev,
                        countries: "",
                      }));
                    }
                  }}
                  error={Boolean(validationError.countries)}
                  helperText={validationError.countries}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <AsyncDropdown
                  value={payoutTypeSelected}
                  options={payoutTypes}
                  objKey={"payoutType"}
                  stylized
                  label={"payoutType"}
                  handleChange={(value) =>
                    handleDropDownChange(value, dropDowns.PAYOUTTYPE)
                  }
                  error={Boolean(validationError?.payoutType)}
                  helperText={validationError?.payoutType}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <TextField
                  fullWidth
                  multiline
                  name={"cost"}
                  type={"number"}
                  value={affiliateData?.cost}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Cost"}
                  error={Boolean(validationError.cost)}
                  helperText={validationError.cost}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <TextField
                  fullWidth
                  multiline
                  name={"contactEmail"}
                  type={"email"}
                  value={affiliateData?.contactEmail}
                  onChange={handleInputChange}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Contact Email"}
                  error={Boolean(validationError.contactEmail)}
                  helperText={validationError.contactEmail}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <TextField
                  fullWidth
                  multiline
                  name={"billingEmail"}
                  type={"text"}
                  value={affiliateData?.billingEmail}
                  onChange={handleInputChange}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Billing Email"}
                  error={Boolean(validationError.billingEmail)}
                  helperText={validationError.billingEmail}
                />
              </Grid>

              <Grid item xs={2} sm={4} md={4}>
                <TextField
                  fullWidth
                  multiline
                  name={"ipFraudScore"}
                  type={"number"}
                  value={Number(affiliateData?.ipFraudScore)}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"IPQS Fraud Score"}
                  error={Boolean(validationError.ipFraudScore)}
                  helperText={validationError.ipFraudScore}
                />
              </Grid>

              <Grid item xs={2} sm={4} md={4}>
                <TextField
                  fullWidth
                  multiline
                  name={"emailFraudScore"}
                  type={"number"}
                  value={Number(affiliateData?.emailFraudScore)}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #f0f0f0",
                    },
                  }}
                  label={"Email Fraud Score"}
                  error={Boolean(validationError.emailFraudScore)}
                  helperText={validationError.emailFraudScore}
                />
              </Grid>

              <Grid item xs={2} sm={4} md={4}>
                <Checkbox
                  name="vpn"
                  id="checkVpnVerify"
                  onChange={handleCheckBoxChange}
                  checked={affiliateData?.vpn}
                />
                <span>VPN</span>
                <Checkbox
                  name="proxy"
                  id="checkProxy"
                  onChange={handleCheckBoxChange}
                  checked={affiliateData?.proxy}
                />
                <span>Proxy</span>
              </Grid>
              
            </Grid>
            <Stack
              mt={2}
              direction={"row"}
              spacing={2}
              justifyContent="flex-end"
            >
              <MyComponent disabled={loading} onClick={handleSubmit}>
                {loading ? (
                  <CircularProgress
                    size={"21px"}
                    sx={{ margin: "0 14px", color: "black", padding: 0 }}
                  />
                ) : type === "edit-affiliate" ? (
                  "Update"
                ) : (
                  "Save"
                )}
              </MyComponent>
              <MyComponent onClick={handleCancel}>Cancel</MyComponent>
            </Stack>
          </Paper>
        </Stack>
      </Box>
      <SnackBarAlert open={alert} handleClose={handleCloseAlert} />
    </>
  );
};

export default CreateAffiliate;
